__turbopack_context__.v({
  "active": "TabbedSection-module__m73jbW__active",
  "colour__badoo": "TabbedSection-module__m73jbW__colour__badoo",
  "colour__bff": "TabbedSection-module__m73jbW__colour__bff",
  "colour__bumble": "TabbedSection-module__m73jbW__colour__bumble",
  "copy": "TabbedSection-module__m73jbW__copy",
  "mobile__logo": "TabbedSection-module__m73jbW__mobile__logo",
  "tab": "TabbedSection-module__m73jbW__tab",
  "tab__cta": "TabbedSection-module__m73jbW__tab__cta",
  "tab__left": "TabbedSection-module__m73jbW__tab__left",
  "tab__navigation": "TabbedSection-module__m73jbW__tab__navigation",
  "tab__right": "TabbedSection-module__m73jbW__tab__right",
  "tabbed__section": "TabbedSection-module__m73jbW__tabbed__section",
  "tabs": "TabbedSection-module__m73jbW__tabs",
});
